import { useState, useCallback } from 'react';
import { Video } from '../types';
import { videoService } from '../services/video.service';

export const useVideos = () => {
    const [videos, setVideos] = useState<Video[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [showForm, setShowForm] = useState(false);
    const [editingVideo, setEditingVideo] = useState<Video | undefined>(undefined);

    const fetchVideos = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await videoService.getAll();
            setVideos(data);
        } catch (err) {
            setError('Error al cargar los vídeos');
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    const handleCreate = useCallback(() => {
        setEditingVideo(undefined);
        setShowForm(true);
    }, []);

    const handleEdit = useCallback((video: Video) => {
        setEditingVideo(video);
        setShowForm(true);
    }, []);

    const handleDelete = useCallback(async (id: number) => {
        if (window.confirm('¿Estás seguro de que quieres eliminar este vídeo?')) {
            try {
                await videoService.delete(id);
                await fetchVideos();
            } catch (err) {
                alert('Error al eliminar el vídeo');
            }
        }
    }, [fetchVideos]);

    const handleCloseForm = useCallback(() => {
        setShowForm(false);
        setEditingVideo(undefined);
        fetchVideos();
    }, [fetchVideos]);

    return {
        videos,
        loading,
        error,
        showForm,
        editingVideo,
        fetchVideos,
        handleCreate,
        handleEdit,
        handleDelete,
        handleCloseForm
    };
};
